import request from '../request';

export const getReportDataUsage = async (params: any) => {
  const url = `/api/Provider/report/data-usage/enterprise`;
  const res = await request('get', url, params);
  if (res.isSucceeded) {
    return res.data;
  }
};
